import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { JwtAuthHeaders } from '../../../models/jwt-auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { Invite } from '../schemas/invite.schema';
import { smsNotificationServiceEnvironment } from '../sms-notification-service-environment';

/**
 * Make a request to send an SMS notification to one or many phone number associated with assets. Note that a success does not guarantee delivery.
 * @param partnerId Partner ID
 * @param accountId Account ID
 * @param invites Array of invites, which include the phone number, associated asset, and body of the SMS notification
 * @returns Object containing success attribute
 */
export function postSmsNotificationSend(
  this: unknown,
  partnerId: string,
  accountId: string,
  invites: Invite[]
) {
  return fromFetch(
    new Request(
      smsNotificationServiceEnvironment.resolve(this).smsNotificationSendUrl,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new JwtAuthHeaders(),
        },
        body: JSON.stringify({
          partnerId,
          accountId,
          invites,
        }),
      }
    )
  ).pipe(
    selectData(
      z.object({
        invalidInvites: z.array(
          z.object({
            body: z.string(),
            entityId: z.string(),
            entityType: z.string(),
            errorCode: z.number(),
            message: z.string(),
            productFamily: z.string(),
            toPhoneNumber: z.string(),
          })
        ),
        requestId: z.string(),
        success: z.boolean(),
      })
    )
  );
}
